import React, { Component } from 'react'
import {Alert,Label,Row,Col,Table,Input,Button,Spinner,FormGroup} from 'reactstrap'
import {connect } from 'react-redux';
import {getData} from "../../Redux/ducks/mainReducer";
import {datesDiffe} from "../../GeneralFunctions/general"
import ReactJsAlert from "reactjs-alert"

export class ClosedLoans extends Component {
    state={
        isLoading:false,
        msg:null,
        mainData:null,
        searchAction:null,
        nameSearch:null,
        startFrom:null,
        endAt:null,
        alertStatus:false,
        alertType:"error",
        alertTitle:null,
    }

    componentDidUpdate(prevProps){
        const{userData,msg,userDataStatus} = this.props;
        if(userDataStatus !== prevProps.userDataStatus){
            if(userDataStatus===true){
                this.setState({isLoading:false,mainData:userData})
            }else if(userDataStatus===false){
                this.setState({isLoading:false,mainData:null,alertStatus:true,alertType:"error",alertTitle:msg})
            }
        }
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    setSearchValue = (e) =>{
        this.setState({nameSearch:e.target.value,searchAction:e.target.id})
    }

    searchData = () =>{
        const {startFrom,endAt} = this.state

        if(startFrom ===null || endAt ===null){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Fill in all feilds marked with a *"})
        }else if(datesDiffe(startFrom,endAt,null)<0){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"'Start From' date can not be greater than 'End At' date *"})
        }else{
            this.setState({isLoading:true})
            const data = new FormData();
            data.append("startFrom",startFrom);
            data.append("endAt",endAt);
            this.props.getData(data,"CLOSED_LOANSDATA")
        }
    }

    renderLoanRow = (values,myNo,i) => (
        <tr key={i}>
            <td>{myNo}</td>
            <th scope="row">{values.loanID}</th>
            <td>{values.member.firstName+" "+values.member.lastName}</td>
            <td>{values.member.clubNumber}</td>
            <td>{values.paytype == null? "": values.paytype.name}</td>
            <td>{values.period}</td>
            <td>{values.rate}</td>
            <td>{values.amount}</td>
            <td>{values.amountExpected}</td>
            <td>{values.amountPaid}</td>
            <td>{values.loanBalance}</td>
            <td>{values.entryDate}</td>
            <td>{values.endDate}</td>
            <td>{values.closedAt}</td>
            <td>{Math.round(values.amount / values.period)}</td>
            <td>{values.details}</td>
            <td>{values.created_at}</td>
        </tr>
    )

    render() {
        const {mainData,nameSearch,searchAction} = this.state;
        let closedLoanDataList = [];
        let myNo = 0
        let amountGiven = 0
        let totalBalance = 0

        if(mainData !==null){
            const loanData = mainData.loanData
            if(loanData.length>0){
                loanData.forEach((values, i) =>{
                    const hasSearch = nameSearch !== null && nameSearch !== ""
                    const matchesLoan = searchAction ==="LOANID" && values.loanID === nameSearch.toUpperCase()
                    const matchesAccount = searchAction ==="ACCOUNT" && values.member.clubNumber === nameSearch.toUpperCase()

                    if(!hasSearch || matchesLoan || matchesAccount){
                        myNo = myNo+1
                        amountGiven = amountGiven+parseInt(values.amount)
                        totalBalance = totalBalance+parseInt(values.loanBalance)
                        closedLoanDataList.push(this.renderLoanRow(values,myNo,i))
                    }
                })
            }else{
                closedLoanDataList.push(
                    <tr key="empty">
                        <td colSpan="17"><br/><Alert color="primary">No closed loans found in the selected range</Alert></td>
                    </tr>
                )
            }
        }

        return (
            <div>
                <Row className="mainWrraper">
                    <div className="block-header">
                        <h4>VIEW CLOSED LOANS</h4>
                    </div>
                    <Col xs="12" className="mainWrraper" >
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        <Col xs="12" md="12" className="tableWrapper">
                            <Row>
                                <Col md="4" xs="12">
                                    <FormGroup>
                                        <Label for="dob">Start From*</Label>
                                        <Input type="date" onChange={this.setValue} value={this.state.startFrom} name="startFrom"/>
                                    </FormGroup>
                                </Col>
                                <Col md="4" xs="12">
                                    <FormGroup>
                                        <Label for="dob">End At*</Label>
                                        <Input type="date" onChange={this.setValue} value={this.state.endAt} name="endAt"/>
                                    </FormGroup>
                                </Col>
                                <Col md="4" xs="12">
                                    <FormGroup>
                                        <Label for="dob"></Label>
                                        <Button onClick={this.searchData} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Search</Button>
                                    </FormGroup>
                                </Col>
                                <Col md="12" xs="12">
                                    <Label className='balB'>TOTAL LOANS : {myNo.toLocaleString()}, TOTAL AMOUNT GIVEN :{amountGiven.toLocaleString()}, TOTAL LOAN BAL : {totalBalance.toLocaleString()}</Label>
                                </Col>
                            </Row>
                            <div className='table-container'>
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Loan ID</th>
                                            <th>Member</th>
                                            <th>Member No.</th>
                                            <th>Loan Type</th>
                                            <th>Period(Month)</th>
                                            <th>Rate(%)</th>
                                            <th>Loan Amount</th>
                                            <th>Amount Expected</th>
                                            <th>Amount Paid</th>
                                            <th>Loan Balance</th>
                                            <th>Entry Date</th>
                                            <th>End Date</th>
                                            <th>Closure Date</th>
                                            <th>Installment</th>
                                            <th>Details</th>
                                            <th>Date</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="LOANID" ?this.state.nameSearch:null} id="LOANID"/></th>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="ACCOUNT" ?this.state.nameSearch:null} id="ACCOUNT"/></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {this.state.isLoading?
                                    <tbody>
                                        <tr>
                                            <td colSpan="17">
                                                <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                            </td>
                                        </tr>
                                    </tbody>:
                                    <tbody>
                                        {closedLoanDataList}
                                    </tbody>}
                                </Table>
                            </div>
                        </Col>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    userDataStatus : state.mainReducer.getMyDataStatus,
    msg : state.mainReducer.msg,
    userData : state.mainReducer.getMyData,
});

export default connect(
    mapStateToProps,
    {getData}
)(ClosedLoans)
